// extracted by mini-css-extract-plugin
module.exports = {"ratingDivider":"az_pcd","ratingItem":"az_qcd"};